/** Backend grava "agora" como relógio de Brasília (UtcNow - 3h) sem fuso no JSON. */
const BRT_OFFSET_MS = 3 * 60 * 60 * 1000;

/** ISO sem fuso (relógio de Brasília) -> ms "wall-clock" (interpretado como UTC, sem depender do fuso do navegador). */
export const parseBrt = (iso?: string | null): number | undefined => {
  if (!iso) return undefined;
  const hasZone = /(Z|[+-]\d{2}:?\d{2})$/.test(iso);
  const ms = Date.parse(hasZone ? iso : `${iso}Z`);
  return Number.isNaN(ms) ? undefined : ms;
};

/** "Agora" no mesmo referencial de parseBrt. */
export const nowBrt = (): number => Date.now() - BRT_OFFSET_MS;

/** Segundos decorridos desde o instante (ISO de Brasília) até agora; nunca negativo. */
export const secondsSince = (iso?: string | null): number | undefined => {
  const start = parseBrt(iso);
  return start === undefined ? undefined : Math.max(0, Math.floor((nowBrt() - start) / 1000));
};

/** "3d 4h", "2h 15m", "12m", "<1m". */
export const formatDuration = (totalSeconds?: number | null): string => {
  if (totalSeconds === undefined || totalSeconds === null || Number.isNaN(totalSeconds)) return "—";
  const s = Math.max(0, Math.floor(totalSeconds));
  const days = Math.floor(s / 86400);
  const hours = Math.floor((s % 86400) / 3600);
  const minutes = Math.floor((s % 3600) / 60);
  if (days > 0) return `${days}d ${hours}h`;
  if (hours > 0) return `${hours}h ${minutes}m`;
  if (minutes > 0) return `${minutes}m`;
  return "<1m";
};

/** Duração formatada desde `iso` até agora, ou undefined sem data. */
export const formatSince = (iso?: string | null): string | undefined => {
  const s = secondsSince(iso);
  return s === undefined ? undefined : formatDuration(s);
};
